import { c as _c } from "react/compiler-runtime";
import { KeyValueSkeleton } from "@/components/domain/key-value-skeleton";
import { PillCountSkeleton } from "@/components/domain/pill-count";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
function DnsGroupSkeleton(t0) {
  const $ = _c(11);
  const {
    title,
    records: t1
  } = t0;
  const records = t1 === undefined ? 2 : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <div className="text-[11px] tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">{title}</div>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PillCountSkeleton />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className="flex items-center gap-2 leading-none">{t2}{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== records || $[6] !== title) {
    t5 = <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">{Array.from({
        length: records
      }, (_, n) => `dns-skel-${title}-${records}-${n}`).map(_temp)}</div>;
    $[5] = records;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="space-y-2">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(id) {
  return <KeyValueSkeleton key={id} withTrailing={true} trailingClassName="h-[22px] w-14" widthClass="w-[100px]" />;
}
export function DnsSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReportSection isLoading={true} {...sections.dns}><div className="space-y-4"><DnsGroupSkeleton title="A Records" /><DnsGroupSkeleton title="AAAA Records" /><DnsGroupSkeleton title="MX Records" /><DnsGroupSkeleton title="TXT Records" records={4} /><DnsGroupSkeleton title="NS Records" /></div></ReportSection>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}